import { isSweepstakesQuery, FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { BALANCE_CURRENCY_UPDATED, Feature } from '@gig/magic-messages';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';

/**
 * The CoreX balance can be either:
 * - the normal user balance
 * - the Sweepstakes balance
 *
 * This component essentially switches between these 2 views based on the app config
 */
var Balance = /** @class */ (function (_super) {
    __extends(Balance, _super);
    function Balance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Current users currency
         */
        _this.currency = null;
        _this.isSweepstakes = false;
        _this.freeToPlayBalance = false;
        _this.Currency = Currency;
        _this.currencySubscription = null;
        return _this;
    }
    Balance.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, isSweepstakesQuery()];
                    case 1:
                        _a.isSweepstakes = _b.sent();
                        if (!this.isSweepstakes) {
                            this.getCurrencyUpdates();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Balance.prototype.hasExtraItem = function () {
        return this.$slots['extra-item'];
    };
    Balance.prototype.destroyed = function () {
        var _a;
        (_a = this.currencySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    Balance.prototype.getCurrencyUpdates = function () {
        var _this = this;
        this.currencySubscription = window.eventBus.subscribe(BALANCE_CURRENCY_UPDATED, function (e) {
            _this.currency = e.payload;
        }, { replay: true });
    };
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], Balance.prototype, "delay", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], Balance.prototype, "compact", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], Balance.prototype, "gameplay", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], Balance.prototype, "fullscreen", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.FREE_TO_PLAY_BALANCE }),
        __metadata("design:type", Boolean)
    ], Balance.prototype, "freeToPlayBalance", void 0);
    Balance = __decorate([
        Component({
            name: 'corex-balance',
        })
    ], Balance);
    return Balance;
}(Mixins(MagicConfigMixin)));

export default Balance;
